export function bytesToBase64(bytes) {
  if (!bytes) {
    return null;
  }
  let binaryString = '';
  for (let i = 0; i < bytes.length; i++) {
    binaryString += String.fromCharCode(bytes[i]);
  }
  return btoa(binaryString);
}
